import { Command, HttpMethod } from "~/extensions/api";
export class FindFilesInfoCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "common/files/info/find");
    }
    informationNo = null;
    BuknCd = null;
    UserCd = null;
    OrgNyukyokeiyakuNo = null;
    ShomeiNo = null;
    fileList = [];
}
export class FindFileItemCommand {
    constructor(fileFetchKb, fileCode) {
        this.fileFetchKb = fileFetchKb;
        this.fileCode = fileCode;
    }
    fileFetchKb = null;
    fileCode = null;
}
